<template>
  <transition name="pop">
    <div class="modal-mask modal-backdrop">
      <loading v-model:active="loading" />
      <div
        class="modal-wrapper animate__fadeInDown animate__animated"
        v-if="showModel"
      >
        <div class="modal-dialogs" role="document">
          <div class="modal-content modal-xs bank_data_details">
            <h1 class="tm5 modal-title d-inline-block">Bank</h1>
            <span class="bitter-font text-white bal-span">
              Ingame: <span class="label-default">{{ wwsToken }} WWS</span>
              <span class="label-warning">{{ wwgToken }} WWG</span>
            </span>
            <span class="bitter-font text-white bal-span">
              Wallet: <span class="label-default">{{ wwsTokenWallet }}</span>
              <span class="label-warning" v-if="wwgTokenWallet">{{
                wwgTokenWallet
              }}</span>
            </span>
            <a
              href="JavaScript:void(0)"
              class="btn-cross text-right close-modal animate__fadeInDown animate__animated"
              @click="hideModal($event)"
              >&times;</a
            >
            <div class="modal-body mdScroll px-lg-5 px-md-5 px-4 pb-5">
              <p v-if="error">{{ error }}</p>
              <!-- Tap button Start -->
              <ul class="nav nav-pills justify-content-around">
                <li class="nav-item">
                  <a
                    href="javascript:void(0)"
                    class="btn btn-land nav-link"
                    :class="{ active: isActive('deposit') }"
                    data-toggle="pill"
                    role="tab"
                    aria-controls="pills-deposit"
                    aria-selected="false"
                    @click.prevent="setActive('deposit')"
                    >Deposit</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    href="#withdrew"
                    class="btn nav-link"
                    data-toggle="pill"
                    role="tab"
                    aria-controls="pills-withdrew"
                    aria-selected="true"
                    @click.prevent="setActive('withdraw')"
                    :class="{ active: isActive('withdraw') }"
                    >Withdrew</a
                  >
                </li>
              </ul>
              <!-- Tap button End -->

              <!-- Tap Content Star -->
              <div class="tab-content">
                <div
                  class="tab-pane fade"
                  :class="{ 'active show': isActive('deposit') }"
                  id="flamingo"
                  role="tabpanel"
                  aria-labelledby="flamingo-tab"
                >
                  <div class="row flex-column align-items-center mt-3">
                    <h4 class="text-white">Deposit Amount</h4>
                    <div class="form-group w-75 d-flex deposit_amountInner">
                      <input
                        type="number"
                        class="form-control my-3"
                        v-model="amount"
                        placeholder="Deposit amount, e.g 1"
                      />
                      <select v-model="symbol" class="token-select my-3 ml-3">
                        <option value="WWS">WWS</option>
                        <option value="WWG">WWG</option>
                      </select>
                    </div>
                    <div class="text-center w-100 attack_btn">
                      <button @click="deposit()">Deposit</button>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  :class="{ 'active show': isActive('withdraw') }"
                  id="withdraw"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <div class="row flex-column align-items-center mt-3">
                    <h4 class="text-white">Withdraw Amount</h4>
                    <small class="text-warning">8% Withdraw Fee</small>
                    <div class="form-group w-75 input-field d-flex">
                      <input
                        type="number"
                        class="form-control my-3"
                        v-model="amountWithdraw"
                        placeholder="Withdraw amount, e.g 1"
                      />
                      <select v-model="symbol" class="token-select my-3 ml-3">
                        <option value="WWS">WWS</option>
                        <option value="WWG">WWG</option>
                      </select>
                    </div>
                    <div class="text-center w-50 attack_btn">
                      <button @click="withdraw()">Withdraw</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Tap Content End -->
        </div>
      </div>
    </div>
  </transition>
</template>
  <script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import ApiService from "../../services/index";
import { mapGetters } from "vuex";
import "vue-loading-overlay/dist/vue-loading.css";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  name: "WalletInfoModal",
  components: {
    Loading,
  },
  computed: {
    ...mapGetters(["wwsToken", "wwgToken", "wwgTokenWallet", "wwsTokenWallet"]),
  },
  props: ["error", "showModel"],
  showModal: true,
  data() {
    return {
      amount: null,
      amountWithdraw: null,
      token: false,
      loading: false,
      symbol: "WWS",
      activeItem: "deposit",
    };
  },
  methods: {
    hideModal(e) {
      this.$emit("w-modal-hide-click", e);
    },
    isActive(menuItem) {
      return this.activeItem === menuItem;
    },
    setActive(menuItem) {
      this.activeItem = menuItem;
    },
    getBal() {
      ApiService.getInGameBalance((res) => {
        if (res.rows[0] !== undefined) {
          let bal = res.rows[0].balances;
          this.$store.commit("addBalance", bal);
        }
      });
      ApiService.getWalletBalance((res) => {
        let bal = res.data;
        this.$store.commit("addWalletBal", bal);
      });
      this.loading = false;
    },
    async withdraw() {
      if (!this.symbol || !this.amountWithdraw) {
        toast.error("Please select amount and token type.");
        return;
      }
      if (this.amountWithdraw > this.wwsToken) {
        toast.error("Input amount is greater than available balance.");
        return;
      }
      this.loading = true;
      const data = {
        contract: process.env.VUE_APP_CONTRACT,
        action: "withdraw",
        data: {
          account: localStorage.getItem("wax_user"),
          token: Number(this.amountWithdraw).toFixed(4) + " " + this.symbol,
        },
      };
      await ApiService.transaction(
        data,
        (res) => {
          if (res.processed) {
            toast.success("Transaction successfull");
            this.getBal();
          }
        },
        (error) => {
          toast.error(ApiService.errorFormat(error));
          this.loading = false;
        }
      );
    },
    async deposit() {
      if (!this.amount) {
        toast.error("No Input amount provided.");
        return;
      }
      this.loading = true;
      const data = {
        contract: process.env.VUE_APP_TOKEN_CONTRACT,
        action: "transfer",
        data: {
          from: localStorage.getItem("wax_user"),
          quantity: Number(this.amount).toFixed(4) + " " + this.symbol,
          to: process.env.VUE_APP_CONTRACT,
          memo: "deposit:coins",
        },
      };
      await ApiService.transaction(
        data,
        (res) => {
          if (res.processed) {
            toast.success("Transaction successfull");
            this.getBal();
          }
        },
        (error) => {
          toast.error(ApiService.errorFormat(error));
        }
      );
    },
  },
};
</script>
  
  <style scoped>
.modal-mask {
  font-family: "Skranji", cursive !important;
}
.progress-cont .progress__bar {
  height: 9px !important;
}
.token {
  background: #eeac33;
  padding: 3px 10px;
  border-radius: 10px;
  font-size: 14px;
}

span {
  font-family: "Skranji";
  letter-spacing: 1px;
}
.nav-link {
  font-size: 19px;
}
.modal-wrapper .modal-content {
  height: auto;
  padding: 44px 21px;
}
.modal-wrapper .modal-dialogs .modal-content .close-modal {
  top: 39px;
  right: 65px;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: transparent !important;
  border-bottom: 4px solid white !important;
}
.btn.focus,
.btn:focus {
  outline: none !important;
  box-shadow: none !important;
}
.nav-pills .btn {
  border-radius: 0;
}
.nav-pills .nav-link {
  color: #eeac33;
}
.bal-span {
  margin: 3px auto;
  width: 85%;
  padding: 2px;
}
@media (max-width: 768px) {
  .deposit_amountInner {
    width: 90% !important;
  }
  .modal-wrapper .modal-content {
    padding: 60px 21px;
  }
  .modal-wrapper .modal-dialogs .modal-content .close-modal {
    top: 60px;
    right: 40px;
  }
}
</style>
  